import { RefObject, useCallback, useEffect, useRef } from 'react';

// Минимальное количество событий для того, чтобы считать, что событие пользовательское, а не подскролл браузера
const MIN_NUMBER_SCROLL_EVENTS = 2;

// Временное окно, в течение которого считаем события скролла
const PERIOD_OF_TIME_FOR_SCROLL_EVENTS_IN_MS = 400;

export function useVisualViewportScrollLock({ enabled, ref }: { enabled: boolean; ref: RefObject<HTMLElement> }) {
    // Считаем события скролла для того, чтобы игнорировать браузерный подскролл при клике на label на ios
    const scrollEventCounter = useRef(0);
    const scrollTimerId = useRef<ReturnType<typeof setTimeout>>();

    const onScroll = useCallback(() => {
        if (
            enabled &&
            ref.current &&
            document.activeElement &&
            scrollEventCounter.current >= MIN_NUMBER_SCROLL_EVENTS
        ) {
            ref.current.focus();
        }

        if (scrollTimerId.current) {
            clearTimeout(scrollTimerId.current);
        }

        scrollEventCounter.current += 1;
        scrollTimerId.current = setTimeout(() => {
            scrollEventCounter.current = 0;
        }, PERIOD_OF_TIME_FOR_SCROLL_EVENTS_IN_MS);
    }, [enabled, ref]);

    useEffect(() => {
        if (typeof window === 'undefined' || !window.visualViewport) {
            return;
        }

        const visualViewport = window.visualViewport;
        const timerId = scrollTimerId.current;

        visualViewport.addEventListener('scroll', onScroll);

        return () => {
            visualViewport.removeEventListener('scroll', onScroll);
            scrollEventCounter.current = 0;

            if (timerId) {
                clearTimeout(timerId);
            }
        };
    });
}
